import { imageMimeTypeExtensions, videoMimeTypeExtensions } from './mimeType';

export const fileTypes = {
  DOCUMENT: 1,
  IMAGE: 2,
  VIDEO: 3,
};

export const getFileTypeFromFile = (file) => {
  if (imageMimeTypeExtensions.isImage(file.type)) {
    return fileTypes.IMAGE;
  }

  if (videoMimeTypeExtensions.isVideo(file.type)) {
    return fileTypes.VIDEO;
  }
  return fileTypes.DOCUMENT;
}

export default fileTypes;
